
// Import Vendors
import FarloUiLightbox from './vendors/farlo-ui-lightbox';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox';
import FarloUiNumberInput from './vendors/farlo-ui-numberinput.js';
import FarloUiList from './vendors/farlo-ui-list.js';
import FarloUiRevolverCarousel from './vendors/farlo-ui-revolver-carousel';
import FarloUiTicketCalendar from './vendors/farlo-ui-ticket-calendar';
import addLightboxToGallery from './vendors/farlo-ui-gallery-lightbox.js';

// Import Footer Components
import { farloUiCrmSignup } from './components/footer/farloUiCrmSignup.js';
import { elementInView } from './components/footer/elementInView.js';
import { toggleFAQ } from './components/footer/toggleFAQ.js';
import { faqs } from './components/footer/faqs.js';
import { navigation, navicon } from './components/footer/navigation.js';
import { smoothScrollToAnchor } from './components/footer/smoothScrollToAnchor.js';
import { embedOverlay } from './components/footer/embedOverlay.js';
import { mapLoader } from './components/footer/mapLoader.js';
import { crmActiveInput } from './components/footer/crmActiveInput.js';
import { crmPopup } from './components/footer/crmPopup.js';
import { openingLoader } from './components/footer/openingLoader.js';
import { unFixMasthead } from './components/footer/unFixMasthead.js';

((document, window, history) => {
	const pushState = history.pushState;

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.farlo-ss-loader')) {
			openingLoader();
		}

		if (document.querySelector('.site-masthead__slides')) {
			unFixMasthead();
		}

		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.site-navigation__sub-menu')) {
			document.querySelectorAll('.site-navigation__sub-menu').forEach((_sel) => {
				navigation(_sel);
			});
		}

		if (document.querySelector('#rank-math-faq')) {
			document.querySelector('#rank-math-faq').addEventListener('click', () => {
				setTimeout(function() {
					document.querySelector('.site-collapsible-section__content').style.setProperty('--section-height', document.querySelector('#rank-math-faq').scrollHeight);
				}, 300);
			});
		}

		if (document.querySelector('.farlo-ui-crm__input')) {
			crmActiveInput();
		}

		if (document.querySelector('.farlo-ui-crm--inline')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiCrmSignup(_sel);
			});
		}

		if (document.querySelector('.is-style-lightbox-gallery')) {
			addLightboxToGallery();
		}

		if (document.querySelectorAll('.wp-block-embed')) {
			embedOverlay();
		}
		if (document.querySelector('.farlo-ui-crm__toggle')) {
			const buttons = document.querySelectorAll('.farlo-ui-crm__toggle');
			buttons.forEach((button) => {
				button.addEventListener('click', (e) => {
					e.preventDefault();
					e.stopImmediatePropagation();
					farloUiCrmSignup(e);
				});
			});
		}
		if (document.querySelector('.wp-block-embed')) {
			document.querySelectorAll('.wp-block-embed__wrapper').forEach(function(_sel) {
				const embedDiv = document.createElement('div');

				if (!(_sel.querySelector('.wp-block-embed__player'))) {
					embedDiv.className = 'wp-block-embed__player';
					_sel.append(embedDiv);

					embedDiv.addEventListener('click', (e) => {
						const iframe = e.currentTarget.parentNode.querySelector('iframe');
						const dataSrc = iframe.getAttribute('data-src');

						e.currentTarget.parentNode.classList.toggle('wp-block-embed__wrapper--is-playing');

						if (dataSrc) {
							iframe.setAttribute('src', dataSrc + '&autoplay=1&playsinline=1&muted=1');
						} else {
							const src = iframe.getAttribute('src');
							iframe.setAttribute('src', src + '&autoplay=1&playsinline=1&muted=1');
						}
					});
				}
			});
		}

		if (document.querySelector('.farlo-ui-map')) {
			mapLoader();
		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			smoothScrollToAnchor(_sel);
		});

		if (document.querySelector('.rank-math-question')) {
			document.querySelectorAll('.rank-math-question').forEach((question) => {
				const answer = question.nextElementSibling;

				// Set accessibility attributes
				question.setAttribute('role', 'button');
				question.setAttribute('tabindex', '0');
				question.setAttribute('aria-expanded', 'false');
				answer.setAttribute('aria-hidden', 'true');
				answer.style.height = '0px'; // Initialize height

				// Click toggle
				question.addEventListener('click', () => {
					toggleFAQ(question);
				});

				// Keyboard toggle
				question.addEventListener('keydown', (e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						toggleFAQ(question);
					}
				});
			});
		}

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		if (document.querySelector('.farlo-ui-animated')) {
			document.querySelectorAll('.farlo-ui-animated').forEach((_sel) => {
				elementInView(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-ticket-calendar')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				new FarloUiTicketCalendar(_sel);
			});
		}

		if (document.querySelector('select')) {
			document.querySelectorAll('select').forEach((_sel) => {
				new FarloUiSelectBox(_sel);
			});
		}
		if (document.querySelector('input[type="number"]')) {
			document.querySelectorAll('input[type="number"]').forEach((numberInput) => {
				new FarloUiNumberInput(numberInput);
			});
		}

		if (document.querySelector('.gfield_list_icons')) {
			document.querySelectorAll('.gfield_list_icons').forEach(function(buttonContainer) {
				new FarloUiList(buttonContainer);
			});
		}

		if (document.querySelector('.farlo-ui-lightbox__toggle')) {
			document.querySelectorAll('.farlo-ui-lightbox__toggle').forEach((_sel) => {
				new FarloUiLightbox(_sel);
			});
		}

		if (document.querySelector('.site-collapsible-section')) {
			document.querySelectorAll('.site-collapsible-section__header').forEach((_sel) => {
				_sel.addEventListener('click', () => {
					const contentSection = _sel.nextElementSibling;
					if (contentSection) {
						_sel.classList.toggle('site-collapsible-section__open');
						contentSection.style.setProperty('--section-height', (contentSection.clientHeight ? 0 : contentSection.scrollHeight));
					}
				});
			});

			if (window.location.hash === '#faqs') {
				const faqHeader = document.querySelector(".site-collapsible-section__header[data-section='faqs']");
				if (faqHeader) {
					const contentSection = faqHeader.nextElementSibling;
					if (contentSection) {
						faqHeader.classList.add('site-collapsible-section__open');
						contentSection.style.setProperty('--section-height', contentSection.scrollHeight);
					}
				}
			}
		}

		if (document.querySelector('.farlo-ui-revolver-carousel')) {
			document.querySelectorAll('[farlo-ui="carousel"]').forEach((_sel) => {
				new FarloUiRevolverCarousel(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-crm__popup-onload')) {
			crmPopup();
		}
	});

	function initMarquee(marquee) {
		if (!marquee) {
			return;
		}

		const track = marquee.querySelector('.farlo-ui-marquee-track');
		if (!track) {
			return;
		}

		// Duplicate content for infinite scroll
		const clone = track.cloneNode(true);
		track.appendChild(clone);
	}

	document.querySelectorAll('.farlo-ui-marquee').forEach((_marquee) => {
		initMarquee(_marquee);
	});

	if (typeof navigator !== 'undefined') {
		navigator.serviceWorker.getRegistrations().then(function(registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}

	let resizeTimer;
	let lastWidth = window.innerWidth;

	window.addEventListener('resize', () => {
		// ignore height-only changes (address-bar show/hide)
		if (window.innerWidth === lastWidth) {
			return;
		}
		lastWidth = window.innerWidth;

		document.body.classList.add('resize-animation-stopper');
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			document.body.classList.remove('resize-animation-stopper');
		}, 400);
	});
})(document, window, history);
